import styles from './ReferralRewardSection.module.scss';
import { useGetReferralsInfo } from 'src/hooks';
import { useMemo } from 'react';
import cn from 'classnames';

export const ReferralRewardSection = () => {
  const { referralsInfo } = useGetReferralsInfo();
  const max = referralsInfo?.max_subscription_extension_months || 0;
  const earned = referralsInfo?.subscription_extension_months || 0;
  const percentage = useMemo(() => (earned * 100) / max || 2, [earned, max]);
  return (
    <div className={styles.root}>
      <h6 className={styles.title}>Your referrals reward</h6>
      <div className={styles.bar}>
        <div
          className={cn(styles.fill, { [styles.fullWidth]: percentage >= 100 })}
          style={{ width: `${percentage}%` }}
        />
      </div>
      <div className={styles.labelRow}>
        <span className={styles.earned}>Earned {earned} free months</span>
        <span className={styles.max}>Max. {max} months</span>
      </div>
    </div>
  );
};
